import { axiosV2 } from 'interceptors/axios';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

export const getSharesTitlesByPartnerOperations =
  (partnerId: string, operationIds: string[]) => async (dispatch: any) => {
    const body = { partnerId, operationIds };

    try {
      const { data } = await axiosV2.post(
        '/sharesTitles/partner-operations',
        body
      );

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
